import React from 'react';
import Button from '4all-ui/components/Button';
import { compose } from 'redux';
import ServiceMenu from '../../services/Menu';
import { getExportProducts, clearExportProducts } from '../../helpers/session';
import ScreenEmpty from '../../components/ScreenEmpty';
import DisabledMenuModal from '../../components/GenericModal/DisabledMenuModal/';
import DeleteMenuModal from '../../components/DeleteMenuModal';
import PlusIcon from '../../images/icon-plus.svg';
import ErrorHandler from '../../components/ErrorHandler';
import Loader from '../../components/Loader';
import MenuItem from '../../components/MenuItem';
import Navbar from '../../components/Navbar';
import CreateMenuModal from '../../components/CreateMenuModal';
import * as styles from './style';
import { MENU_ELEMENT_ID_PREFIX } from '../../helpers/constants';
import withMerchant from '../../containers/Merchant';
import { withMenus } from '../../containers/Menus';
import withProducts from '../../containers/Products';
import withMenuModals from '../../containers/Modals/menu';
import Helper from '../../helpers/Helper';
import withScrollTo from '../../containers/ScrollTo';

class Menu extends React.Component {
  state = {
    showEditName: false,
    error: false,
  };

  componentDidMount() {
    const { getAllProductsByStatus, getProducts } = this.props;
    const { canExport, categories } = this.checkExportProducts();

    this.getMenuList();

    if (!canExport) {
      getAllProductsByStatus(1);
    } else {
      getProducts(categories, canExport);
    }
  }

  componentDidUpdate() {
    const {
      products,
      merchant,
      isPublishMenuFinished,
      finishReceiveProducts,
      openModal,
      finishSetMerchant,
      getMenus,
      finishPublishMenu,
      finishReceiveByStatus,
    } = this.props;

    if (merchant.isSetMerchantFinished) {
      if (products.export) {
        openModal();
      }
      finishSetMerchant();
    }

    if (isPublishMenuFinished) {
      finishPublishMenu();
      getMenus();
    }

    if (finishReceiveProducts) {
      finishReceiveByStatus();
    }
  }

  hideEditName = () => {
    this.setState({ showEditName: false });
  };

  publish = (menu, value) => {
    const { publishMenu } = this.props;

    publishMenu(value, menu);
  };

  updateName = (menu, value) => {
    if (value) {
      const { getMenus } = this.props;

      new ServiceMenu()
        .patch(menu.id, { name: value, merchantId: menu.merchantId })
        .then(() => {
          this.setState({ showEditName: false });
          getMenus();
        })
        .catch(err => {
          console.error('error', err);
        });
    }
  };

  checkElementToScroll = el => {
    const { clearScrollTo } = this.props;
    const menuElement = document.getElementById(`${MENU_ELEMENT_ID_PREFIX}${el.id}`);

    if (menuElement) {
      Helper.scrollToElement(menuElement);
    }

    clearScrollTo();
  };

  showContent = () => {
    const { menus, isLoadingMenus, categories, openModal } = this.props;
    const { error } = this.state;

    if (error) {
      return (
        <ErrorHandler>
          <div>
            <p>Opa, não conseguimos localizar nenhum</p>
            <p>cardápio, por favor tente recarregar a página.</p>
          </div>
        </ErrorHandler>
      );
    }

    if (!isLoadingMenus && !menus.length) {
      return (
        <ScreenEmpty
          message={
            categories.length
              ? 'Você não possui nenhum cardápio cadastrado no momento'
              : 'Você não possui nenhum produto cadastrado ou ativo no momento'
          }
          btnMessage="Cardápio"
          btnClass="btn-add-menu"
          onClick={openModal}
          showButton={!!categories.length}
        />
      );
    }

    return <styles.MenuItem>{menus.map(this.renderMenu)}</styles.MenuItem>;
  };

  renderMenu = (menu, i) => {
    const { merchant, onClickMenuActions } = this.props;
    const { showEditName, menuEdit } = this.state;

    return (
      <MenuItem
        key={i}
        menu={menu}
        merchantMktps={merchant.marketplaces}
        showEditName={showEditName}
        menuEdit={menuEdit}
        hideEditName={this.hideEditName}
        updateName={this.updateName}
        onClickActions={onClickMenuActions}
        publish={this.publish}
      />
    );
  };

  getMenuList = async () => {
    const { getMenus, scrollTo } = this.props;

    await getMenus();

    if (scrollTo.id) {
      this.checkElementToScroll(scrollTo);
    }
  };

  checkExportProducts() {
    const exportProducts = getExportProducts();
    const { canExport } = exportProducts;
    let categories = [];

    if (canExport) {
      categories = exportProducts.categories.map(cat => ({
        ...cat,
        products: cat.products.map(prod => ({
          ...prod,
          categoryId: cat.id,
        })),
      }));

      clearExportProducts();
    }

    return {
      canExport,
      categories,
    };
  }

  render() {
    const { isLoadingMenus, categories } = this.props;

    return (
      <div>
        <Navbar
          button={
            <Button
              id="btn-add-menus"
              onClick={this.props.openModal}
              disabled={!categories.length}
              customStyles={{
                padding: '10px 15px',
              }}
            >
              <img
                src={PlusIcon}
                alt="Ícone do botão de adicionar"
                style={{ marginRight: '10px' }}
              />
              Cardápio
            </Button>
          }
        />
        <Loader show={isLoadingMenus} />

        {this.showContent()}

        <DisabledMenuModal container={this} />
        <DeleteMenuModal />
        <CreateMenuModal />
      </div>
    );
  }
}

export default compose(
  withMenuModals,
  withMerchant,
  withMenus,
  withProducts,
  withScrollTo
)(Menu);



// WEBPACK FOOTER //
// ./src/screens/Menu/index.js